import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "./csat-plus.module.css";
import csatWebBanner from "../../assets/images/csat/CSAT-PLUS_Web_Banner_1903x438_08_01_2024 (1).webp";
import table from "../../assets/images/csat/full width.png";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Link from 'next/link';


const Csat = () => {
    const benefitlist = [
        { list: "Complete overview of CSAT course" },
        { list: "Shortcuts for time management and accuracy" },
        { list: "Topper’s Interaction" },
        { list: "Strategy to select easy and eliminate difficult questions which fetch more marks." },
        { list: "Strategy to improve and manage the English skills to understand the question." },
        { list: "Previous year CSAT paper Analysis (Topic wise)" },
    ]

    return (
        <>

            <Head>
                <meta charset="UTF-8" />
                <link rel="icon" href="./logo.png" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>Csat Plus - Shankar IAS Academy</title>
                <meta name="title" content="Csat Plus - Shankar IAS Academy" />
                <meta name="description" content="Shankar IAS Academy" />
                <link rel="canonical" href="https://www.shankariasacademy.com/csat-plus/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Csat Plus - Shankar IAS Academy" />
                <meta property="og:description" content="Shankar IAS Academy" />
                <meta property="og:url" content="https://www.shankariasacademy.com/csat-plus/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
            </Head>
            <Navbar title="upsc" />

            <div className="container">
                <div className="pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>CSAT Plus - Shankar IAS Academy</h1>
                </div>
            </div>


            <div className="container">
                <div className="py-1 py-md-3">
                    <Image src={csatWebBanner} className="img-fluid w-100" alt="csat-plus" title="csat-plus" />
                </div>
                
                <div className='pt-3'>
                    <Image src={table} className="img-fluid w-100" alt="table banner" title="table banner" />
                </div>
                <div className='d-none d-lg-block'>
                <div className={`${styles.tablescroll} prelimstable`}>
                    <table className="table">
                        <thead className={`${styles.table}`} >
                            <tr>
                                <td className={`${styles.tableheading}`}>Course<br /></td>
                                <td className={`${styles.tableheading}`}>Starts From<br /></td>
                                <td className={`${styles.tableheading}`}>Price<br /></td>
                                <td className={`${styles.tableheading}`}>Admission<br /></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="pt-2">
                                <td className={`${styles.tablepara}`}>CSAT plus-refresher course<br /></td>
                                <td className={`${styles.tablepara}`}>09.02.2024<br />
                                    <p className={`${styles.tablepara}`}>*11:00 am to 01:30 pm</p>
                                </td>
                                <td className={`${styles.tablepara}`}>₹6000<br /></td>
                                <td><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
            </div>
            {/* mobile view table*/}
            <div className="container d-lg-none">
                <div className="">
                    <hr />
                    <p className={`${styles.mbtableheading} `}>CSAT plus-refresher course<br /></p>
                    <p className={`${styles.tablepara}`}>09.02.2024<br />*11:00 am to 01:30 pm</p>
                    <div className={`${styles.tablepara}`}>₹6000</div>
                    <br />
                    <div className='text-end'><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></div>
                    <hr />
                </div>
            </div>

            <div style={{ backgroundColor: "#F4F6F8" }}>
                <div className="container py-5">
                    <div className="row">
                        <div className="col">
                            <p className={`${styles.sectionsubtitle} ps-3`}>Benefits of the course:</p>
                            <ul className={``}>
                                {benefitlist.map((item, index) => (
                                    <li
                                        className={`${styles.acheiverrank}`}
                                        id={styles.acheiverrankspecial} key={index}
                                    >
                                        <div className="d-inline">
                                            <p className={`d-inline`}>
                                                {item.list}
                                            </p>
                                        </div>
                                    </li>
                                ))}
                            </ul>

                            <div className='ps-3 mb-2'>
                                <Link href="/pdf/CSAT plus - Brochure - 2024.pdf" target='_blank'>
                                    <button className={`${styles.redbtn}`} type="submit">Click Here To Get Brochure</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default Csat;